/**
 * Session management API client
 */

// ApiClient will be passed in constructor

export interface BrowserSession {
  id: string;
  status: 'active' | 'stopped' | 'inactive';
  live_view_url?: string;
  cdp_url?: string;
  created_at: string;
  stopped_at?: string;
  config?: {
    session: {
      recording?: { active: boolean };
      proxy?: { type: string; country_code: string; active: boolean };
      timeout?: { max_duration: number; idle_timeout: number };
      live_view?: { read_only: boolean };
    };
    browser: {
      profile?: { name: string; persist: boolean };
      adblock?: { active: boolean };
      headless?: { active: boolean };
      viewport?: { width: number; height: number };
    };
  };
}

export interface CreateSessionRequest {
  proxy_country_code?: string;
  use_proxy?: boolean;
  use_adblock?: boolean;
  browser_viewport_width?: number;
  browser_viewport_height?: number;
}

export interface SessionListResponse {
  sessions: BrowserSession[];
  total: number;
}

export class SessionsApi {
  private client: any;

  constructor(client: any) {
    this.client = client;
  }

  /**
   * List all active sessions for the organization
   */
  async listSessions(): Promise<SessionListResponse> {
    console.log('SessionsApi.listSessions called');
    
    try {
      const response = await this.client.request('/sessions', {
        method: 'GET'
      });

      console.log('SessionsApi.listSessions success:', response);
      return response as SessionListResponse;
    } catch (error) {
      console.error('SessionsApi.listSessions error:', error);
      throw error;
    }
  }

  /**
   * Create a new browser session
   */
  async createSession(request: CreateSessionRequest = {}): Promise<BrowserSession> {
    console.log('SessionsApi.createSession called with:', request);
    
    try {
      const response = await this.client.request('/sessions', {
        method: 'POST',
        body: JSON.stringify(request)
      });

      console.log('SessionsApi.createSession success:', response);
      return response as BrowserSession;
    } catch (error) {
      console.error('SessionsApi.createSession error:', error);
      throw error;
    }
  }

  /**
   * Get session details
   */
  async getSession(sessionId: string): Promise<BrowserSession> {
    console.log('SessionsApi.getSession called with:', sessionId);
    
    try {
      const response = await this.client.request(`/sessions/${sessionId}`, {
        method: 'GET'
      });

      console.log('SessionsApi.getSession success:', response);
      return response as BrowserSession;
    } catch (error) {
      console.error('SessionsApi.getSession error:', error);
      throw error;
    }
  }

  /**
   * Stop/delete a session
   */
  async stopSession(sessionId: string): Promise<void> {
    console.log('SessionsApi.stopSession called with:', sessionId);
    
    try {
      await this.client.request(`/sessions/${sessionId}`, {
        method: 'DELETE'
      });

      console.log('SessionsApi.stopSession success');
    } catch (error) {
      console.error('SessionsApi.stopSession error:', error);
      throw error;
    }
  }
}
